import { useEffect } from "react";
import { useLocation } from "react-router-dom";

let curUrl = "";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (curUrl !== location.pathname) {
      window.scrollTo(0, 0);
      curUrl = location.pathname;
    }
  }, [location]);

  return null;
};

export default ScrollToTop;
